module.exports = __webpack_public_path__ + "img/1549104608.c8d4877a.jpg";